export interface BaseApiResponse<T> {
  status: string;
  data: T;
  message?: string;
}

export type HttpClientResponse<T> = [() => void, Promise<T | null>];

export interface IHttpRequestConfig {
  params?: Record<string, unknown>;
  data?: unknown;
  noJSendFormat?: boolean;
  dontUseBaseUrl?: boolean;
  headers?: Record<string, string>;
}

export interface JSendValidationErrorResponse {
  data: {
    validation: Record<string, string>;
  };
}

export interface JSendValidationContractErrorResponse {
  data: Record<string, string>;
}

export const isJSendValidationContractErrorResponse = (
  res: unknown,
): res is JSendValidationContractErrorResponse =>
  Object.keys((res as JSendValidationContractErrorResponse).data)[0].startsWith(
    '[',
  );

export const isJSendValidationErrorResponse = (
  res: unknown,
): res is JSendValidationErrorResponse =>
  'validation' in (res as JSendValidationErrorResponse).data;

export const isJSendErrorResponse = (res: unknown): res is JSendErrorResponse =>
  'data' in (res as JSendErrorResponse);

export interface JSendErrorResponse {
  data: {
    message?: string;
    data?: {
      identifier?: string;
    };
  };
}

export interface IHttpClient {
  get<T>(
    url: string,
    requestConfig?: IHttpRequestConfig,
  ): HttpClientResponse<T>;

  post<T>(
    url: string,
    requestConfig?: IHttpRequestConfig,
  ): HttpClientResponse<T>;

  put<T>(
    url: string,
    requestConfig?: IHttpRequestConfig,
  ): HttpClientResponse<T>;

  patch<T>(
    url: string,
    requestConfig?: IHttpRequestConfig,
  ): HttpClientResponse<T>;

  delete<T>(
    url: string,
    requestConfig?: IHttpRequestConfig,
  ): HttpClientResponse<T>;

  getBaseURL(): string;

  setBedarfId(bedarfId: string | undefined): void;

  setToken(token: string | undefined): void;

  getToken(): string | undefined;
}
